import AirdomeAccess from '../../../base/forms/user/AirdomeAccess';

const airdomeAccess: AirdomeAccess = {
  header: 'Přístup k hale',
  submit: 'Potvrdit'
};

export default airdomeAccess;
